import { useState, useCallback } from 'react';
import { whatsappGroupsApi, ChatMessage } from '../api/whatsapp-groups.api';

export function useOperationChat() {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendMessage = useCallback(async (userMessage: string) => {
    if (!userMessage.trim()) return;

    // Add user message to chat
    const userMsg: ChatMessage = {
      role: 'user',
      content: userMessage,
      timestamp: new Date(),
    };

    setMessages(prev => [...prev, userMsg]);
    setIsLoading(true);
    setError(null);

    try {
      // Send to API with conversation history (excluding the just-added user message)
      const response = await whatsappGroupsApi.sendChatMessage({
        message: userMessage,
        conversationHistory: messages,
      });

      // Add AI response to chat
      const aiMsg: ChatMessage = {
        role: 'assistant',
        content: response.data.data.response,
        timestamp: new Date(response.data.data.timestamp),
      };

      setMessages(prev => [...prev, aiMsg]);
    } catch (err: unknown) {
      const errorMessage = err && typeof err === 'object' && 'response' in err
        ? (err.response as { data?: { message?: string } })?.data?.message || 'Erro ao enviar mensagem'
        : 'Erro ao enviar mensagem';
      setError(errorMessage);

      // Add error message to chat
      const errorMsg: ChatMessage = {
        role: 'assistant',
        content: `Desculpe, ocorreu um erro: ${errorMessage}`,
        timestamp: new Date(),
      };
      setMessages(prev => [...prev, errorMsg]);
    } finally {
      setIsLoading(false);
    }
  }, [messages]);

  const clearChat = useCallback(() => {
    setMessages([]);
    setError(null);
  }, []);

  return {
    messages,
    isLoading,
    error,
    sendMessage,
    clearChat,
  };
}
